import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _accountBrandedAppInfo = { app: '_brandedApp' };
var _activityLogEvent = { dateCreated: 'google.protobuf.Timestamp' };
var _addEmailRequest = {};
var _addEmailResponse = {};
var _addFirebaseAccountRequest = {};
var _addFirebaseAccountResponse = {};
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _appleStoreCredentials = {
    provisioningProfile: 'google.protobuf.BytesValue',
    certificate: 'google.protobuf.BytesValue',
    appStoreConnectApiKey: '_appStoreConnectApiKey',
};
var _appStoreConfig = {
    publishInfo: '_publishInfo',
    inAppPurchase: '_iapInAppPurchase',
};
var _appStoreConnectApiKey = { key: 'google.protobuf.BytesValue' };
var _assignToRequest = {};
var _assignWixMemberEmailsRequest = {};
var _assignWixMemberEmailsResponse = {};
var _availability = {
    start: 'google.protobuf.Timestamp',
    end: 'google.protobuf.Timestamp',
    locations: '_location',
};
var _bookingsResponse = { service: '_service', schedules: '_schedule' };
var _brandedApp = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    storesConfig: '_storesConfig',
};
var _brandedAppAdminItem = {
    brandedAppData: '_brandedAppAdminItemBrandedAppData',
    latestSubmission: '_brandedAppAdminItemSubmission',
    note: '_brandedAppAdminItemNote',
};
var _brandedAppAdminItemBrandedAppData = {
    applePublishInfo: '_publishInfo',
    googlePublishInfo: '_google_playPublishInfo',
};
var _brandedAppAdminItemNote = { date: 'google.protobuf.Timestamp' };
var _brandedAppAdminItemSubmission = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    google: '_google_playSubmission',
    apple: '_submission',
};
var _build = {
    lastUpdate: 'google.protobuf.Timestamp',
    updateHistory: '_buildStatus',
};
var _buildRequest = {};
var _buildResponse = {};
var _buildSecrets = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    googlePlay: '_googlePlayCredentials',
    appleStore: '_appleStoreCredentials',
};
var _buildStatus = { time: 'google.protobuf.Timestamp' };
var _bulkReadStoresConfigRequest = {};
var _bulkReadStoresConfigResponse = { storesConfigs: 'Map#_storesConfig' };
var _cleanInvalidSessionsRequest = {};
var _cleanInvalidSessionsResponse = {};
var _cookie = { expiration: 'google.protobuf.Timestamp' };
var _createAppRequest = {};
var _createAppResponse = {};
var _createAppStoreSecretsRequest = {};
var _createAppStoreSecretsResponse = {};
var _createBrandedAppRequest = { app: '_brandedApp' };
var _createBrandedAppResponse = { app: '_brandedApp' };
var _createEventRequest = { event: '_activityLogEvent' };
var _createEventResponse = {};
var _createFreshSessionRequest = {};
var _createFreshSessionResponse = {};
var _createLoginRequest = {};
var _createLoginResponse = { login: '_login' };
var _createRejectionRequest = {};
var _createRejectionResponse = {};
var _createRejectionsRequest = {};
var _createRejectionsResponse = {};
var _createSessionRequest = { cookies: '_cookie' };
var _createSessionResponse = { credentials: '_credentials' };
var _createSubmissionRequest = {};
var _credentials = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    cookies: '_cookie',
};
var _deleteAllRequest = {};
var _deleteAllResponse = {};
var _deleteLoginRequest = {};
var _deleteLoginResponse = {};
var _deleteRejectionRequest = {};
var _deleteSessionRequest = {};
var _deleteSessionResponse = {};
var _deleteUserSecretsRequest = {};
var _deleteUserSecretsResponse = {};
var _extendedQueryResponse = {};
var _fixRejectionRequest = {};
var _fixRejectionResponse = {};
var _generateScreenshotsRequest = {};
var _generateScreenshotsResponse = {};
var _getAppleProductsFromOrderIdRequest = {};
var _getAppleProductsFromOrderIdResponse = {};
var _getAppMessagesRequest = { filter: '_getMessagesRequest' };
var _getBrandedAppRequest = {};
var _getBrandedAppResponse = {
    app: '_brandedApp',
    subEntities: '_subEntities',
};
var _getBuildConfigRequest = {};
var _getBuildConfigResponse = {};
var _getBuildRequest = {};
var _getBuildResponse = {
    latestAndroidBuild: '_build',
    latestIosBuild: '_build',
};
var _getBuildSecretsRequest = {};
var _getBuildSecretsResponse = { secrets: '_buildSecrets' };
var _getBuildStatusRequest = {};
var _getBuildStatusResponse = { statuses: '_buildStatus' };
var _getByMetaSiteIdsRequest = {};
var _getByStatusRequest = {};
var _getDashboardStoreRequest = {};
var _getDashboardStoreResponse = {};
var _getDomainVerificationDataRequest = {};
var _getDomainVerificationDataResponse = {};
var _getEmailToAssignRequest = {};
var _getEmailToAssignResponse = {};
var _getFirebaseAccountToAssignRequest = {};
var _getFirebaseAccountToAssignResponse = {};
var _getFreshSessionRequest = {};
var _getFreshSessionResponse = {};
var _getIapProductsMetaDataRequest = {};
var _getIapProductsMetaDataResponse = {};
var _getLoginRequest = {};
var _getLoginResponse = { login: '_login' };
var _getMessagesRequest = {
    before: 'google.protobuf.Timestamp',
    after: 'google.protobuf.Timestamp',
};
var _getMessagesResponse = { messages: '_message' };
var _getMetaDataRequest = {};
var _getMetaDataResponse = {};
var _getMobileConfigRequest = {};
var _getMobileConfigResponse = {};
var _getPrioritizedAppsRequest = {};
var _getPrioritizedAppsResponse = {
    submissions: '_storesSubmission',
    events: '_activityLogEvent',
};
var _getPublicConfigRequest = {};
var _getPublicConfigResponse = {};
var _getPublicStatusRequest = {};
var _getPublicStatusResponse = { status: '_buildStatus' };
var _getRejectionRequest = {};
var _getRejectionResponse = {};
var _getRejectionsRequest = {};
var _getRejectionsResponse = {};
var _getRemainingEmailUsagesRequest = {};
var _getRemainingEmailUsagesResponse = {};
var _getRemainingFirebaseUsagesRequest = {};
var _getRemainingFirebaseUsagesResponse = {};
var _getSecretsGroupsRequest = {};
var _getSecretsGroupsResponse = {};
var _getSessionsRequest = {};
var _getSessionsResponse = { credentials: '_credentials' };
var _getSiteUrlRequest = {};
var _getSiteUrlResponse = {};
var _getStaticConfigRequest = {};
var _getStaticConfigResponse = {};
var _getStoresConfigRequest = {};
var _getStoresConfigResponse = { storesConfig: '_storesConfig' };
var _getSubmissionRequest = {};
var _getUpdateStatusRequest = {};
var _getUpdateStatusResponse = {};
var _getUserBrandedAppsRequest = {};
var _getUserBrandedAppsResponse = { userApps: '_brandedApp' };
var _getUserSecretsRequest = {};
var _getUserSecretsResponse = { userSecrets: '_userSecrets' };
var _getWithErrorRequest = {};
var _google_playPublishInfo = {
    firstPublishDate: 'google.protobuf.Timestamp',
    lastPublishDate: 'google.protobuf.Timestamp',
};
var _google_playSubmission = { events: '_google_playSubmissionEvent' };
var _google_playSubmissionEvent = { date: 'google.protobuf.Timestamp' };
var _googlePlayCredentials = { keyStore: 'google.protobuf.BytesValue' };
var _iapInAppPurchase = { products: '_product' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _inAppPurchaseProduct = { product: '_product' };
var _inviteWixEmailToAppStoreConnectRequest = {};
var _inviteWixEmailToAppStoreConnectResponse = {};
var _listIapProductsDetailsRequest = {};
var _listIapProductsDetailsResponse = {};
var _listMandatoryProductsRequest = {};
var _listMandatoryProductsResponse = { products: '_product' };
var _listMandatoryProductsV2Request = {};
var _listMandatoryProductsV2Response = { products: '_inAppPurchaseProduct' };
var _location = {
    customAddress: '_address',
    businessLocation: '_locationsLocation',
};
var _locationsAddress = { geocode: '_locationsAddressLocation' };
var _locationsAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _locationsLocation = { address: '_locationsAddress' };
var _login = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
};
var _media = {
    items: '_mediaItem',
    mainMedia: '_mediaItem',
    coverMedia: '_mediaItem',
};
var _mediaItem = { image: '_image' };
var _message = { date: 'google.protobuf.Timestamp' };
var _origin = { paidPlan: '_plan', bookingsResponse: '_bookingsResponse' };
var _partialUpdateBrandedAppRequest = {
    fields: 'google.protobuf.FieldMask',
    app: '_brandedApp',
};
var _partialUpdateBrandedAppResponse = { app: '_brandedApp' };
var _partialUpdateDashboardStoreRequest = {
    fields: 'google.protobuf.FieldMask',
};
var _partialUpdateDashboardStoreResponse = {};
var _plan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _playStoreConfig = { publishInfo: '_google_playPublishInfo' };
var _product = { origin: '_origin' };
var _protosQueryResponse = { apps: '_brandedApp' };
var _publishInfo = {
    firstPublishDate: 'google.protobuf.Timestamp',
    lastPublishDate: 'google.protobuf.Timestamp',
};
var _queryAccountBrandedAppsRequest = { query: '_queryV2' };
var _queryAccountBrandedAppsResponse = {
    accountApps: '_accountBrandedAppInfo',
};
var _queryAccountSitesWithoutBrandedRequest = {};
var _queryAccountSitesWithoutBrandedResponse = {};
var _queryQueueRequest = { query: '_queryV2' };
var _queryQueueResponse = { queuedItems: '_brandedAppAdminItem' };
var _queryResponse = { events: '_activityLogEvent' };
var _queryV2 = {};
var _readBulkRequest = {};
var _readBulkResponse = { apps: 'Map#_brandedApp' };
var _recurringInterval = {
    start: 'google.protobuf.Timestamp',
    end: 'google.protobuf.Timestamp',
};
var _releaseBrandedAppsRequest = {};
var _releaseBrandedAppsResponse = {};
var _retryCurrentSubmissionStageRequest = {};
var _reuseBuildSecretsRequest = {};
var _reuseBuildSecretsResponse = {};
var _savePushNotificationCredentialsRequest = {};
var _schedule = {
    firstSessionStart: 'google.protobuf.Timestamp',
    lastSessionEnd: 'google.protobuf.Timestamp',
    created: 'google.protobuf.Timestamp',
    updated: 'google.protobuf.Timestamp',
    intervals: '_recurringInterval',
    location: '_location',
    availability: '_availability',
};
var _searchAdminAppsRequest = { query: '_queryV2' };
var _searchAdminAppsResponse = { adminApps: '_brandedAppAdminItem' };
var _selectProductsRequest = {};
var _selectProductsResponse = {};
var _sendBrandedMarketingEmailRequest = {};
var _sendBrandedMarketingEmailResponse = {};
var _service = { info: '_serviceInfo' };
var _serviceInfo = { images: '_image', media: '_media' };
var _session_refresherUpdateSessionRequest = { cookies: '_cookie' };
var _session_refresherUpdateSessionResponse = {};
var _storesConfig = {
    playStore: '_playStoreConfig',
    appStore: '_appStoreConfig',
};
var _storesQueryResponse = { submissions: '_storesSubmission' };
var _storesSubmission = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    google: '_google_playSubmission',
    apple: '_submission',
};
var _storeUpdate = { dateCreated: 'google.protobuf.Timestamp' };
var _subEntities = {
    secrets: '_buildSecrets',
    builds: '_getBuildResponse',
    submission: '_storesSubmission',
};
var _submission = { events: '_submissionEvent' };
var _submissionEvent = { date: 'google.protobuf.Timestamp' };
var _submissionResponse = { submission: '_storesSubmission' };
var _submissionsResponse = { submissions: 'Map#_storesSubmission' };
var _submitAppRequest = {};
var _submitAppResponse = { submission: '_storesSubmission' };
var _syncProductsRequest = {};
var _syncProductsResponse = { products: '_product' };
var _syncProductsV2Request = {};
var _syncProductsV2Response = {};
var _triggerEventBulkRequest = {
    apple: '_submissionEvent',
    google: '_google_playSubmissionEvent',
};
var _triggerEventBulkResponse = {};
var _triggerEventRequest = {
    apple: '_submissionEvent',
    google: '_google_playSubmissionEvent',
};
var _updateAppleAppPublishedStatusRequest = {};
var _updateAppleAppPublishedStatusResponse = { publishInfo: '_publishInfo' };
var _updateBrandedAppRequest = { app: '_brandedApp' };
var _updateBrandedAppResponse = { app: '_brandedApp' };
var _updateBuildConfigRequest = {};
var _updateBuildConfigResponse = {};
var _updateBuildSecretsRequest = { secrets: '_buildSecrets' };
var _updateBuildSecretsResponse = { secrets: '_buildSecrets' };
var _updateBuildStatusRequest = { status: '_buildStatus' };
var _updateBuildStatusResponse = {};
var _updateDashboardStoreRequest = {};
var _updateDashboardStoreResponse = {};
var _updateGoogleAppPublishedStatusRequest = {};
var _updateGoogleAppPublishedStatusResponse = {};
var _updateLoginRequest = {};
var _updateLoginResponse = { login: '_login' };
var _updateMobileConfigRequest = {};
var _updateMobileConfigResponse = {};
var _updatePreferredAppRequest = {};
var _updatePreferredAppResponse = {};
var _updatePublishedAppsRequest = {};
var _updatePublishedAppsResponse = { storeUpdate: '_storeUpdate' };
var _updateRejectionRequest = {};
var _updateRejectionResponse = {};
var _updateSessionRequest = { cookies: '_cookie' };
var _updateSessionResponse = { credentials: '_credentials' };
var _updateStaticConfigRequest = {};
var _updateStaticConfigResponse = {};
var _updateStoreListingsRequest = {};
var _updateStoreListingsResponse = {};
var _updateStoresConfigRequest = { storesConfig: '_storesConfig' };
var _updateStoresConfigResponse = { storesConfig: '_storesConfig' };
var _userSecrets = { secrets: '_buildSecrets' };
var _validateAPNSRequest = {};
var _validateAppleAndGoogleReadyRequest = {};
var _validateAppleAndGoogleReadyResponse = {
    google: '_validResponse',
    apple: '_validResponse',
};
var _validateAppleIsReadyRequest = {};
var _validateAppStoreConnectRequest = { apiKey: '_appStoreConnectApiKey' };
var _validateGcpInviteSentRequest = {};
var _validateGoogleIsReadyRequest = {};
var _validateImageRequest = {};
var _validatePlayConsoleInviteSentRequest = {};
var _validResponse = {};
function resolveComWixpressBrandedappsProtosAdminActivityLogServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/activity-log',
                destPath: '/v1/app/activity-log',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/activity-log',
                destPath: '/v1/app/activity-log',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosAdminQueueAdminQueueServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/admin-queue',
                destPath: '/v1/app/admin-queue',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/admin-queue',
                destPath: '/v1/app/admin-queue',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submission',
                destPath: '/v1/app/stores/submission',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submissions',
                destPath: '/v1/app/stores/submissions',
            },
            {
                srcPath: '/_api/branded-apps/v1/submission',
                destPath: '/v1/submission',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submission',
                destPath: '/v1/app/stores/submission',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submissions',
                destPath: '/v1/app/stores/submissions',
            },
            {
                srcPath: '/_api/branded-apps/v1/submission',
                destPath: '/v1/submission',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submission',
                destPath: '/v1/app/stores/submission',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submissions',
                destPath: '/v1/app/stores/submissions',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresAppleIapProductsResolverServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/apple-iap-psp',
                destPath: '/rest-api',
            },
            {
                srcPath: '/_api/apple-iap-psp/v1/iap/products-from-order-id',
                destPath: '/proto/v1/iap/products-from-order-id',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/apple-iap-psp',
                destPath: '/rest-api',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/iap/products-from-order-id',
                destPath: '/proto/v1/iap/products-from-order-id',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/iap',
                destPath: '/v1/app/stores/iap',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/iap',
                destPath: '/v1/app/stores/iap',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/iap',
                destPath: '/v1/app/stores/iap',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/iap/products-details',
                destPath: '/v1/app/stores/iap/products-details',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresAppleUnofficialAppleUnofficialFacadeServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-unofficial-api-facade',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/branded-apps-unofficial-api-facade',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/branded-apps-unofficial-api-facade',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/validations',
                destPath: '/v1/app/validations',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/validations',
                destPath: '/v1/app/validations',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/validations',
                destPath: '/v1/app/validations',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-lifecycle-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresStoresUpdatesServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/update',
                destPath: '/v1/app/stores/update',
            },
            {
                srcPath: '/v1/app/stores/update',
                destPath: '/v1/app/stores/update',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/update',
                destPath: '/v1/app/stores/update',
            },
            {
                srcPath: '/v1/app/stores/update',
                destPath: '/v1/app/stores/update',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresStoresConfigServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/mobile-config',
                destPath: '/v1/app/mobile-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores-config',
                destPath: '/v1/app/stores-config',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosStoresSubmissionManagementServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submission',
                destPath: '/v1/app/stores/submission',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submissions',
                destPath: '/v1/app/stores/submissions',
            },
            {
                srcPath: '/_api/branded-apps/v1/submission',
                destPath: '/v1/submission',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submission',
                destPath: '/v1/app/stores/submission',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submissions',
                destPath: '/v1/app/stores/submissions',
            },
            {
                srcPath: '/_api/branded-apps/v1/submission',
                destPath: '/v1/submission',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submission',
                destPath: '/v1/app/stores/submission',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores/submissions',
                destPath: '/v1/app/stores/submissions',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosMobileMobileConfigServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/mobile-config',
                destPath: '/v1/app/mobile-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores-config',
                destPath: '/v1/app/stores-config',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosBuildBuildOrchestratorServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-build-orchestrator',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/builds',
                destPath: '/v1/app/builds',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosBuildBuildConfigServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/mobile-config',
                destPath: '/v1/app/mobile-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores-config',
                destPath: '/v1/app/stores-config',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-secrets-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
            {
                srcPath: '/_api/branded-apps/v1/secrets/groups',
                destPath: '/v1/secrets/groups',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app/secrets',
                destPath: '/v1/app/secrets',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/mobile-config',
                destPath: '/v1/app/mobile-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores-config',
                destPath: '/v1/app/stores-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/site-url',
                destPath: '/v1/site-url',
            },
            {
                srcPath: '/_api/branded-apps/v1/user/apps',
                destPath: '/v1/user/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/account/apps',
                destPath: '/v1/account/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/account/sites-without-branded',
                destPath: '/v1/account/sites-without-branded',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/account/apps',
                destPath: '/v1/account/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/account/sites-without-branded',
                destPath: '/v1/account/sites-without-branded',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosBrandedAppServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/mobile-config',
                destPath: '/v1/app/mobile-config',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/stores-config',
                destPath: '/v1/app/stores-config',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/build-config',
                destPath: '/v1/app/build-config',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
            {
                srcPath: '/_api/branded-apps/v1/apps',
                destPath: '/v1/apps',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app',
                destPath: '/v1/app',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosConfigConfigServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosCookieMonsterCookieMonsterServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/branded-apps-cookie-monster-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/branded-apps-cookie-monster-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-cookie-monster-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosDashboardStoreDashboardStoreServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/dashboard-store',
                destPath: '/v1/app/dashboard-store',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosEmailEmailServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosValidationValidationServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/validations',
                destPath: '/v1/app/validations',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/validations',
                destPath: '/v1/app/validations',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
            {
                srcPath: '/_api/branded-apps/v1/app/validations',
                destPath: '/v1/app/validations',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/branded-apps/v1/app/lifecycle',
                destPath: '/v1/app/lifecycle',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-lifecycle-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosLoginLoginServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-login-secrets-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/branded-apps-login-secrets-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/branded-apps-login-secrets-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosRejectionsRejectionsServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosScreenshotsScreenshotsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/generate-screenshots',
                destPath: '/v1/app/generate-screenshots',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/generate-screenshots',
                destPath: '/v1/app/generate-screenshots',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/generate-screenshots',
                destPath: '/v1/app/generate-screenshots',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosSessionRefresherSessionRefresherServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/branded-apps-unofficial-api-session-refresher',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/branded-apps-unofficial-api-session-refresher',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/branded-apps-unofficial-api-session-refresher',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosMarketingMarketingMailerServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/brandedMarketingEmail',
                destPath: '/v1/app/brandedMarketingEmail',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/branded-apps/v1/app/brandedMarketingEmail',
                destPath: '/v1/app/brandedMarketingEmail',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/branded-apps/v1/app/brandedMarketingEmail',
                destPath: '/v1/app/brandedMarketingEmail',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBrandedappsProtosRejectionsRejectionsMetadataServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Create rejections for a given metasiteid */
export function createRejection(payload) {
    var _a = serializer(_createRejectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRejectionResponse, {}).fromJSON;
    function __createRejection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsMetadataService.CreateRejection',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsMetadataServiceUrl({ protoPath: '/v1/app/rejection', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createRejection.fromReq = fromReq;
    __createRejection.__isAmbassador = true;
    return __createRejection;
}
/** Get rejections for a given metasiteid */
export function getRejection(payload) {
    var _a = serializer(_getRejectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRejectionResponse, {}).fromJSON;
    function __getRejection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsMetadataService.GetRejection',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsMetadataServiceUrl({ protoPath: '/v1/app/rejection', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRejection.fromReq = fromReq;
    __getRejection.__isAmbassador = true;
    return __getRejection;
}
export function updateRejection(payload) {
    var _a = serializer(_updateRejectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateRejectionResponse, {}).fromJSON;
    function __updateRejection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsMetadataService.UpdateRejection',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsMetadataServiceUrl({ protoPath: '/v1/app/rejection', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateRejection.fromReq = fromReq;
    __updateRejection.__isAmbassador = true;
    return __updateRejection;
}
/** Deletes rejections for a given metasiteid */
export function deleteRejection(payload) {
    var _a = serializer(_deleteRejectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteRejectionRequest, {}).fromJSON;
    function __deleteRejection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'DELETE',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsMetadataService.DeleteRejection',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsMetadataServiceUrl({ protoPath: '/v1/app/rejection', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteRejection.fromReq = fromReq;
    __deleteRejection.__isAmbassador = true;
    return __deleteRejection;
}
export function sendBrandedMarketingEmail(payload) {
    var _a = serializer(_sendBrandedMarketingEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBrandedMarketingEmailResponse, {}).fromJSON;
    function __sendBrandedMarketingEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.marketing.MarketingMailerService.SendBrandedMarketingEmail',
            url: resolveComWixpressBrandedappsProtosMarketingMarketingMailerServiceUrl({
                protoPath: '/v1/app/brandedMarketingEmail/{templateName}/{referralInfo}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBrandedMarketingEmail.fromReq = fromReq;
    __sendBrandedMarketingEmail.__isAmbassador = true;
    return __sendBrandedMarketingEmail;
}
export function getFreshSession(payload) {
    var _a = serializer(_getFreshSessionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFreshSessionResponse, {}).fromJSON;
    function __getFreshSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.session_refresher.SessionRefresherService.GetFreshSession',
            url: resolveComWixpressBrandedappsProtosSessionRefresherSessionRefresherServiceUrl({
                protoPath: '/v1/session-refresher/session',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFreshSession.fromReq = fromReq;
    __getFreshSession.__isAmbassador = true;
    return __getFreshSession;
}
export function sessionRefresherUpdateSession(payload) {
    var _a = serializer(_session_refresherUpdateSessionRequest, { _cookie: _cookie }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_session_refresherUpdateSessionResponse, {}).fromJSON;
    function __sessionRefresherUpdateSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PATCH',
            methodFqn: 'com.wixpress.brandedapps.protos.session_refresher.SessionRefresherService.UpdateSession',
            url: resolveComWixpressBrandedappsProtosSessionRefresherSessionRefresherServiceUrl({
                protoPath: '/v1/session-refresher/session',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sessionRefresherUpdateSession.fromReq = fromReq;
    __sessionRefresherUpdateSession.__isAmbassador = true;
    return __sessionRefresherUpdateSession;
}
/** Create a new session from semi expired cookies and login credentials */
export function createFreshSession(payload) {
    var _a = serializer(_createFreshSessionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFreshSessionResponse, {}).fromJSON;
    function __createFreshSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.session_refresher.SessionRefresherService.CreateFreshSession',
            url: resolveComWixpressBrandedappsProtosSessionRefresherSessionRefresherServiceUrl({
                protoPath: '/v1/session-refresher/session',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFreshSession.fromReq = fromReq;
    __createFreshSession.__isAmbassador = true;
    return __createFreshSession;
}
/** Delete's all invalid sessions for a given email and session type */
export function cleanInvalidSessions(payload) {
    var _a = serializer(_cleanInvalidSessionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cleanInvalidSessionsResponse, {}).fromJSON;
    function __cleanInvalidSessions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.session_refresher.SessionRefresherService.CleanInvalidSessions',
            url: resolveComWixpressBrandedappsProtosSessionRefresherSessionRefresherServiceUrl({ protoPath: '/v1/session-refresher/clean', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cleanInvalidSessions.fromReq = fromReq;
    __cleanInvalidSessions.__isAmbassador = true;
    return __cleanInvalidSessions;
}
export function generateScreenshots(payload) {
    var _a = serializer(_generateScreenshotsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateScreenshotsResponse, {}).fromJSON;
    function __generateScreenshots(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.screenshots.ScreenshotsService.GenerateScreenshots',
            url: resolveComWixpressBrandedappsProtosScreenshotsScreenshotsServiceUrl({
                protoPath: '/v1/app/generate-screenshots',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateScreenshots.fromReq = fromReq;
    __generateScreenshots.__isAmbassador = true;
    return __generateScreenshots;
}
/** Create rejections for a given metasiteid */
export function createRejections(payload) {
    var _a = serializer(_createRejectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRejectionsResponse, {}).fromJSON;
    function __createRejections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsService.CreateRejections',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsServiceUrl({
                protoPath: '/v1/app/rejections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createRejections.fromReq = fromReq;
    __createRejections.__isAmbassador = true;
    return __createRejections;
}
/** Get rejections for a given metasiteid */
export function getRejections(payload) {
    var _a = serializer(_getRejectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRejectionsResponse, {}).fromJSON;
    function __getRejections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsService.GetRejections',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsServiceUrl({
                protoPath: '/v1/app/rejections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRejections.fromReq = fromReq;
    __getRejections.__isAmbassador = true;
    return __getRejections;
}
/** Fix a rejection for a given metasiteid */
export function fixRejection(payload) {
    var _a = serializer(_fixRejectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_fixRejectionResponse, {}).fromJSON;
    function __fixRejection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.rejections.RejectionsService.FixRejection',
            url: resolveComWixpressBrandedappsProtosRejectionsRejectionsServiceUrl({
                protoPath: '/v1/app/rejections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __fixRejection.fromReq = fromReq;
    __fixRejection.__isAmbassador = true;
    return __fixRejection;
}
export function getLogin(payload) {
    var _a = serializer(_getLoginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoginResponse, { _login: _login }).fromJSON;
    function __getLogin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.login.LoginService.GetLogin',
            url: resolveComWixpressBrandedappsProtosLoginLoginServiceUrl({
                protoPath: '/v1/login/secrets',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLogin.fromReq = fromReq;
    __getLogin.__isAmbassador = true;
    return __getLogin;
}
export function createLogin(payload) {
    var _a = serializer(_createLoginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLoginResponse, { _login: _login }).fromJSON;
    function __createLogin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.login.LoginService.CreateLogin',
            url: resolveComWixpressBrandedappsProtosLoginLoginServiceUrl({
                protoPath: '/v1/login/secrets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLogin.fromReq = fromReq;
    __createLogin.__isAmbassador = true;
    return __createLogin;
}
export function updateLogin(payload) {
    var _a = serializer(_updateLoginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLoginResponse, { _login: _login }).fromJSON;
    function __updateLogin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PATCH',
            methodFqn: 'com.wixpress.brandedapps.protos.login.LoginService.UpdateLogin',
            url: resolveComWixpressBrandedappsProtosLoginLoginServiceUrl({
                protoPath: '/v1/login/secrets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLogin.fromReq = fromReq;
    __updateLogin.__isAmbassador = true;
    return __updateLogin;
}
export function deleteLogin(payload) {
    var _a = serializer(_deleteLoginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLoginResponse, {}).fromJSON;
    function __deleteLogin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'DELETE',
            methodFqn: 'com.wixpress.brandedapps.protos.login.LoginService.DeleteLogin',
            url: resolveComWixpressBrandedappsProtosLoginLoginServiceUrl({
                protoPath: '/v1/login/secrets',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLogin.fromReq = fromReq;
    __deleteLogin.__isAmbassador = true;
    return __deleteLogin;
}
export function validateAppStoreConnect(payload) {
    var _a = serializer(_validateAppStoreConnectRequest, { _appStoreConnectApiKey: _appStoreConnectApiKey }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validateAppStoreConnect(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateAppStoreConnect',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/app-store-connect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateAppStoreConnect.fromReq = fromReq;
    __validateAppStoreConnect.__isAmbassador = true;
    return __validateAppStoreConnect;
}
export function validateAppleIsReady(payload) {
    var _a = serializer(_validateAppleIsReadyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validateAppleIsReady(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateAppleIsReady',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/apple-is-ready',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateAppleIsReady.fromReq = fromReq;
    __validateAppleIsReady.__isAmbassador = true;
    return __validateAppleIsReady;
}
export function validateApns(payload) {
    var _a = serializer(_validateAPNSRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validateApns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateAPNS',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/apns',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateApns.fromReq = fromReq;
    __validateApns.__isAmbassador = true;
    return __validateApns;
}
export function validateGcpInviteSent(payload) {
    var _a = serializer(_validateGcpInviteSentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validateGcpInviteSent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateGcpInviteSent',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/gcp-invite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateGcpInviteSent.fromReq = fromReq;
    __validateGcpInviteSent.__isAmbassador = true;
    return __validateGcpInviteSent;
}
export function validatePlayConsoleInviteSent(payload) {
    var _a = serializer(_validatePlayConsoleInviteSentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validatePlayConsoleInviteSent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidatePlayConsoleInviteSent',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/play-console-invite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validatePlayConsoleInviteSent.fromReq = fromReq;
    __validatePlayConsoleInviteSent.__isAmbassador = true;
    return __validatePlayConsoleInviteSent;
}
export function validateGoogleIsReady(payload) {
    var _a = serializer(_validateGoogleIsReadyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validateGoogleIsReady(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateGoogleIsReady',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/google-is-ready',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateGoogleIsReady.fromReq = fromReq;
    __validateGoogleIsReady.__isAmbassador = true;
    return __validateGoogleIsReady;
}
export function validateAppleAndGoogleReady(payload) {
    var _a = serializer(_validateAppleAndGoogleReadyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateAppleAndGoogleReadyResponse, { _validResponse: _validResponse }).fromJSON;
    function __validateAppleAndGoogleReady(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateAppleAndGoogleReady',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/apple-google-is-ready',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateAppleAndGoogleReady.fromReq = fromReq;
    __validateAppleAndGoogleReady.__isAmbassador = true;
    return __validateAppleAndGoogleReady;
}
export function validateImage(payload) {
    var _a = serializer(_validateImageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validResponse, {}).fromJSON;
    function __validateImage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.validation.ValidationService.ValidateImage',
            url: resolveComWixpressBrandedappsProtosValidationValidationServiceUrl({
                protoPath: '/v1/app/validations/validate-image',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateImage.fromReq = fromReq;
    __validateImage.__isAmbassador = true;
    return __validateImage;
}
export function getMessages(payload) {
    var _a = serializer(_getMessagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMessagesResponse, { _message: _message }).fromJSON;
    function __getMessages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.email.EmailService.GetMessages',
            url: resolveComWixpressBrandedappsProtosEmailEmailServiceUrl({
                protoPath: '/v1/emails/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMessages.fromReq = fromReq;
    __getMessages.__isAmbassador = true;
    return __getMessages;
}
export function getAppMessages(payload) {
    var _a = serializer(_getAppMessagesRequest, { _getMessagesRequest: _getMessagesRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMessagesResponse, { _message: _message }).fromJSON;
    function __getAppMessages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.email.EmailService.GetAppMessages',
            url: resolveComWixpressBrandedappsProtosEmailEmailServiceUrl({
                protoPath: '/v1/app/emails',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppMessages.fromReq = fromReq;
    __getAppMessages.__isAmbassador = true;
    return __getAppMessages;
}
/** Get dashboard store for a given metasiteid */
export function getDashboardStore(payload) {
    var _a = serializer(_getDashboardStoreRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDashboardStoreResponse, {}).fromJSON;
    function __getDashboardStore(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.dashboard_store.DashboardStoreService.GetDashboardStore',
            url: resolveComWixpressBrandedappsProtosDashboardStoreDashboardStoreServiceUrl({ protoPath: '/v1/app/dashboard-store', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDashboardStore.fromReq = fromReq;
    __getDashboardStore.__isAmbassador = true;
    return __getDashboardStore;
}
/** Upserts dashboard store for a given metasiteid */
export function updateDashboardStore(payload) {
    var _a = serializer(_updateDashboardStoreRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDashboardStoreResponse, {}).fromJSON;
    function __updateDashboardStore(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.dashboard_store.DashboardStoreService.UpdateDashboardStore',
            url: resolveComWixpressBrandedappsProtosDashboardStoreDashboardStoreServiceUrl({ protoPath: '/v1/app/dashboard-store', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDashboardStore.fromReq = fromReq;
    __updateDashboardStore.__isAmbassador = true;
    return __updateDashboardStore;
}
/** Updates dashboard store for a given metasiteid */
export function partialUpdateDashboardStore(payload) {
    var _a = serializer(_partialUpdateDashboardStoreRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_partialUpdateDashboardStoreResponse, {}).fromJSON;
    function __partialUpdateDashboardStore(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PATCH',
            methodFqn: 'com.wixpress.brandedapps.protos.dashboard_store.DashboardStoreService.PartialUpdateDashboardStore',
            url: resolveComWixpressBrandedappsProtosDashboardStoreDashboardStoreServiceUrl({ protoPath: '/v1/app/dashboard-store', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __partialUpdateDashboardStore.fromReq = fromReq;
    __partialUpdateDashboardStore.__isAmbassador = true;
    return __partialUpdateDashboardStore;
}
export function getSessions(payload) {
    var _a = serializer(_getSessionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSessionsResponse, {
        _cookie: _cookie,
        _credentials: _credentials,
    }).fromJSON;
    function __getSessions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.cookie_monster.CookieMonsterService.GetSessions',
            url: resolveComWixpressBrandedappsProtosCookieMonsterCookieMonsterServiceUrl({ protoPath: '/v1/cookie-monster/session', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSessions.fromReq = fromReq;
    __getSessions.__isAmbassador = true;
    return __getSessions;
}
export function createSession(payload) {
    var _a = serializer(_createSessionRequest, { _cookie: _cookie }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSessionResponse, {
        _cookie: _cookie,
        _credentials: _credentials,
    }).fromJSON;
    function __createSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.cookie_monster.CookieMonsterService.CreateSession',
            url: resolveComWixpressBrandedappsProtosCookieMonsterCookieMonsterServiceUrl({ protoPath: '/v1/cookie-monster/session', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSession.fromReq = fromReq;
    __createSession.__isAmbassador = true;
    return __createSession;
}
export function cookieMonsterUpdateSession(payload) {
    var _a = serializer(_updateSessionRequest, { _cookie: _cookie }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSessionResponse, {
        _cookie: _cookie,
        _credentials: _credentials,
    }).fromJSON;
    function __cookieMonsterUpdateSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PATCH',
            methodFqn: 'com.wixpress.brandedapps.protos.cookie_monster.CookieMonsterService.UpdateSession',
            url: resolveComWixpressBrandedappsProtosCookieMonsterCookieMonsterServiceUrl({ protoPath: '/v1/cookie-monster/session', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cookieMonsterUpdateSession.fromReq = fromReq;
    __cookieMonsterUpdateSession.__isAmbassador = true;
    return __cookieMonsterUpdateSession;
}
export function deleteSession(payload) {
    var _a = serializer(_deleteSessionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSessionResponse, {}).fromJSON;
    function __deleteSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'DELETE',
            methodFqn: 'com.wixpress.brandedapps.protos.cookie_monster.CookieMonsterService.DeleteSession',
            url: resolveComWixpressBrandedappsProtosCookieMonsterCookieMonsterServiceUrl({ protoPath: '/v1/cookie-monster/session', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSession.fromReq = fromReq;
    __deleteSession.__isAmbassador = true;
    return __deleteSession;
}
/** Read static config, used when generating a new build config */
export function getStaticConfig(payload) {
    var _a = serializer(_getStaticConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStaticConfigResponse, {}).fromJSON;
    function __getStaticConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.GetStaticConfig',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStaticConfig.fromReq = fromReq;
    __getStaticConfig.__isAmbassador = true;
    return __getStaticConfig;
}
/** Update static config (full update) */
export function updateStaticConfig(payload) {
    var _a = serializer(_updateStaticConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStaticConfigResponse, {}).fromJSON;
    function __updateStaticConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.UpdateStaticConfig',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStaticConfig.fromReq = fromReq;
    __updateStaticConfig.__isAmbassador = true;
    return __updateStaticConfig;
}
/**
 * Returns next email that is available for assigning to a user
 * Will reduce the number of allowed usages for an email by one
 */
export function getEmailToAssign(payload) {
    var _a = serializer(_getEmailToAssignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEmailToAssignResponse, {}).fromJSON;
    function __getEmailToAssign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.GetEmailToAssign',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config/get-email-to-assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEmailToAssign.fromReq = fromReq;
    __getEmailToAssign.__isAmbassador = true;
    return __getEmailToAssign;
}
/** Will add an email to the bank of available emails for invites, with some starting number (40) */
export function addEmail(payload) {
    var _a = serializer(_addEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addEmailResponse, {}).fromJSON;
    function __addEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.AddEmail',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config/add-email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addEmail.fromReq = fromReq;
    __addEmail.__isAmbassador = true;
    return __addEmail;
}
export function getFirebaseAccountToAssign(payload) {
    var _a = serializer(_getFirebaseAccountToAssignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFirebaseAccountToAssignResponse, {}).fromJSON;
    function __getFirebaseAccountToAssign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.GetFirebaseAccountToAssign',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config/get-firebase-to-assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFirebaseAccountToAssign.fromReq = fromReq;
    __getFirebaseAccountToAssign.__isAmbassador = true;
    return __getFirebaseAccountToAssign;
}
export function addFirebaseAccount(payload) {
    var _a = serializer(_addFirebaseAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addFirebaseAccountResponse, {}).fromJSON;
    function __addFirebaseAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.AddFirebaseAccount',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config/add-firebase',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addFirebaseAccount.fromReq = fromReq;
    __addFirebaseAccount.__isAmbassador = true;
    return __addFirebaseAccount;
}
export function getRemainingEmailUsages(payload) {
    var _a = serializer(_getRemainingEmailUsagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRemainingEmailUsagesResponse, {}).fromJSON;
    function __getRemainingEmailUsages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.GetRemainingEmailUsages',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config/emails/remaining',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRemainingEmailUsages.fromReq = fromReq;
    __getRemainingEmailUsages.__isAmbassador = true;
    return __getRemainingEmailUsages;
}
export function getRemainingFirebaseUsages(payload) {
    var _a = serializer(_getRemainingFirebaseUsagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRemainingFirebaseUsagesResponse, {}).fromJSON;
    function __getRemainingFirebaseUsages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.config.ConfigService.GetRemainingFirebaseUsages',
            url: resolveComWixpressBrandedappsProtosConfigConfigServiceUrl({
                protoPath: '/v1/config/accounts/remaining',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRemainingFirebaseUsages.fromReq = fromReq;
    __getRemainingFirebaseUsages.__isAmbassador = true;
    return __getRemainingFirebaseUsages;
}
/** Get mobile config for an app, if you pass with signed instance as member/user then you'll get full data, otherwise only partial */
export function brandedAppServiceGetBrandedApp(payload) {
    var _a = serializer(_getBrandedAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBrandedAppResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _appStoreConnectApiKey: _appStoreConnectApiKey,
        _appleStoreCredentials: _appleStoreCredentials,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _build: _build,
        _buildSecrets: _buildSecrets,
        _buildStatus: _buildStatus,
        _getBuildResponse: _getBuildResponse,
        _googlePlayCredentials: _googlePlayCredentials,
        _google_playPublishInfo: _google_playPublishInfo,
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
        _storesSubmission: _storesSubmission,
        _subEntities: _subEntities,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __brandedAppServiceGetBrandedApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.GetBrandedApp',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/app',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __brandedAppServiceGetBrandedApp.fromReq = fromReq;
    __brandedAppServiceGetBrandedApp.__isAmbassador = true;
    return __brandedAppServiceGetBrandedApp;
}
/** Upserts mobile config for a given metasiteid */
export function updateBrandedApp(payload) {
    var _a = serializer(_updateBrandedAppRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBrandedAppResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __updateBrandedApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.UpdateBrandedApp',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBrandedApp.fromReq = fromReq;
    __updateBrandedApp.__isAmbassador = true;
    return __updateBrandedApp;
}
/** Upserts mobile config for a given metasiteid */
export function partialUpdateBrandedApp(payload) {
    var _a = serializer(_partialUpdateBrandedAppRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_partialUpdateBrandedAppResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __partialUpdateBrandedApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PATCH',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.PartialUpdateBrandedApp',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __partialUpdateBrandedApp.fromReq = fromReq;
    __partialUpdateBrandedApp.__isAmbassador = true;
    return __partialUpdateBrandedApp;
}
/** Creates branded app config, will use default info for every field that wasn't passed */
export function createBrandedApp(payload) {
    var _a = serializer(_createBrandedAppRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBrandedAppResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __createBrandedApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.CreateBrandedApp',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBrandedApp.fromReq = fromReq;
    __createBrandedApp.__isAmbassador = true;
    return __createBrandedApp;
}
/** Read Bulk branded apps - data will be partial if you lack permissions */
export function brandedAppServiceReadBulk(payload) {
    var _a = serializer(_readBulkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_readBulkResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __brandedAppServiceReadBulk(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.ReadBulk',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __brandedAppServiceReadBulk.fromReq = fromReq;
    __brandedAppServiceReadBulk.__isAmbassador = true;
    return __brandedAppServiceReadBulk;
}
/** Queries all apps */
export function brandedAppServiceQuery(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_protosQueryResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __brandedAppServiceQuery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.Query',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/apps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __brandedAppServiceQuery.fromReq = fromReq;
    __brandedAppServiceQuery.__isAmbassador = true;
    return __brandedAppServiceQuery;
}
/** First it joins all the tables, then allows querying on it */
export function extendedQuery(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_extendedQueryResponse, {}).fromJSON;
    function __extendedQuery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.ExtendedQuery',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/apps/extended-query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __extendedQuery.fromReq = fromReq;
    __extendedQuery.__isAmbassador = true;
    return __extendedQuery;
}
/** Gets required domain verification data */
export function getDomainVerificationData(payload) {
    var _a = serializer(_getDomainVerificationDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDomainVerificationDataResponse, {}).fromJSON;
    function __getDomainVerificationData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.GetDomainVerificationData',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/apps/domain-verification',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDomainVerificationData.fromReq = fromReq;
    __getDomainVerificationData.__isAmbassador = true;
    return __getDomainVerificationData;
}
export function updatePreferredApp(payload) {
    var _a = serializer(_updatePreferredAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePreferredAppResponse, {}).fromJSON;
    function __updatePreferredApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.UpdatePreferredApp',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/apps/preferred-app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePreferredApp.fromReq = fromReq;
    __updatePreferredApp.__isAmbassador = true;
    return __updatePreferredApp;
}
/** Gets public config for a branded app */
export function getPublicConfig(payload) {
    var _a = serializer(_getPublicConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPublicConfigResponse, {}).fromJSON;
    function __getPublicConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppService.GetPublicConfig',
            url: resolveComWixpressBrandedappsProtosBrandedAppServiceUrl({
                protoPath: '/v1/app/public-config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPublicConfig.fromReq = fromReq;
    __getPublicConfig.__isAmbassador = true;
    return __getPublicConfig;
}
/** Get mobile config for an app, if you pass with signed instance as member/user then you'll get full data, otherwise only partial */
export function brandedAppReadServiceGetBrandedApp(payload) {
    var _a = serializer(_getBrandedAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBrandedAppResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _appStoreConnectApiKey: _appStoreConnectApiKey,
        _appleStoreCredentials: _appleStoreCredentials,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _build: _build,
        _buildSecrets: _buildSecrets,
        _buildStatus: _buildStatus,
        _getBuildResponse: _getBuildResponse,
        _googlePlayCredentials: _googlePlayCredentials,
        _google_playPublishInfo: _google_playPublishInfo,
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
        _storesSubmission: _storesSubmission,
        _subEntities: _subEntities,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __brandedAppReadServiceGetBrandedApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.GetBrandedApp',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/app',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __brandedAppReadServiceGetBrandedApp.fromReq = fromReq;
    __brandedAppReadServiceGetBrandedApp.__isAmbassador = true;
    return __brandedAppReadServiceGetBrandedApp;
}
/** Read Bulk branded apps - data will be partial if you lack permissions */
export function brandedAppReadServiceReadBulk(payload) {
    var _a = serializer(_readBulkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_readBulkResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __brandedAppReadServiceReadBulk(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.ReadBulk',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __brandedAppReadServiceReadBulk.fromReq = fromReq;
    __brandedAppReadServiceReadBulk.__isAmbassador = true;
    return __brandedAppReadServiceReadBulk;
}
/** Queries all submissions for the given metasiteid (from context) */
export function brandedAppReadServiceQuery(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_protosQueryResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __brandedAppReadServiceQuery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.Query',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/apps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __brandedAppReadServiceQuery.fromReq = fromReq;
    __brandedAppReadServiceQuery.__isAmbassador = true;
    return __brandedAppReadServiceQuery;
}
/** Read Bulk branded apps - data will be partial if you lack permissions */
export function getSiteUrl(payload) {
    var _a = serializer(_getSiteUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSiteUrlResponse, {}).fromJSON;
    function __getSiteUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.GetSiteUrl',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/site-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSiteUrl.fromReq = fromReq;
    __getSiteUrl.__isAmbassador = true;
    return __getSiteUrl;
}
export function getUserBrandedApps(payload) {
    var _a = serializer(_getUserBrandedAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUserBrandedAppsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __getUserBrandedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.GetUserBrandedApps',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/user/apps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserBrandedApps.fromReq = fromReq;
    __getUserBrandedApps.__isAmbassador = true;
    return __getUserBrandedApps;
}
export function queryAccountSitesWithoutBranded(payload) {
    var _a = serializer(_queryAccountSitesWithoutBrandedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAccountSitesWithoutBrandedResponse, {}).fromJSON;
    function __queryAccountSitesWithoutBranded(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.QueryAccountSitesWithoutBranded',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/account/sites-without-branded',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAccountSitesWithoutBranded.fromReq = fromReq;
    __queryAccountSitesWithoutBranded.__isAmbassador = true;
    return __queryAccountSitesWithoutBranded;
}
export function queryAccountBrandedApps(payload) {
    var _a = serializer(_queryAccountBrandedAppsRequest, { _queryV2: _queryV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAccountBrandedAppsResponse, {
        _accountBrandedAppInfo: _accountBrandedAppInfo,
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _brandedApp: _brandedApp,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __queryAccountBrandedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.BrandedAppReadService.QueryAccountBrandedApps',
            url: resolveComWixpressBrandedappsProtosBrandedAppReadServiceUrl({
                protoPath: '/v1/account/apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAccountBrandedApps.fromReq = fromReq;
    __queryAccountBrandedApps.__isAmbassador = true;
    return __queryAccountBrandedApps;
}
/** Will also call ping asking for push credentials, does not store them */
export function getBuildSecrets(payload) {
    var _a = serializer(_getBuildSecretsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBuildSecretsResponse, {
        _appStoreConnectApiKey: _appStoreConnectApiKey,
        _appleStoreCredentials: _appleStoreCredentials,
        _buildSecrets: _buildSecrets,
        _googlePlayCredentials: _googlePlayCredentials,
    }).fromJSON;
    function __getBuildSecrets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildSecretsService.GetBuildSecrets',
            url: resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl({
                protoPath: '/v1/app/secrets',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBuildSecrets.fromReq = fromReq;
    __getBuildSecrets.__isAmbassador = true;
    return __getBuildSecrets;
}
/** Upserts mobile config for a given app, also updates ping */
export function updateBuildSecrets(payload) {
    var _a = serializer(_updateBuildSecretsRequest, {
        _appStoreConnectApiKey: _appStoreConnectApiKey,
        _appleStoreCredentials: _appleStoreCredentials,
        _buildSecrets: _buildSecrets,
        _googlePlayCredentials: _googlePlayCredentials,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBuildSecretsResponse, {
        _appStoreConnectApiKey: _appStoreConnectApiKey,
        _appleStoreCredentials: _appleStoreCredentials,
        _buildSecrets: _buildSecrets,
        _googlePlayCredentials: _googlePlayCredentials,
    }).fromJSON;
    function __updateBuildSecrets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildSecretsService.UpdateBuildSecrets',
            url: resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl({
                protoPath: '/v1/app/secrets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBuildSecrets.fromReq = fromReq;
    __updateBuildSecrets.__isAmbassador = true;
    return __updateBuildSecrets;
}
/** creates user secrets for source msid if doesn't exist, and reuses secrets for dest msid */
export function reuseBuildSecrets(payload) {
    var _a = serializer(_reuseBuildSecretsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reuseBuildSecretsResponse, {}).fromJSON;
    function __reuseBuildSecrets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildSecretsService.ReuseBuildSecrets',
            url: resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl({
                protoPath: '/v1/app/secrets/attach',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reuseBuildSecrets.fromReq = fromReq;
    __reuseBuildSecrets.__isAmbassador = true;
    return __reuseBuildSecrets;
}
export function getUserSecrets(payload) {
    var _a = serializer(_getUserSecretsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUserSecretsResponse, {
        _appStoreConnectApiKey: _appStoreConnectApiKey,
        _appleStoreCredentials: _appleStoreCredentials,
        _buildSecrets: _buildSecrets,
        _googlePlayCredentials: _googlePlayCredentials,
        _userSecrets: _userSecrets,
    }).fromJSON;
    function __getUserSecrets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildSecretsService.GetUserSecrets',
            url: resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl({
                protoPath: '/v1/app/secrets/user',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserSecrets.fromReq = fromReq;
    __getUserSecrets.__isAmbassador = true;
    return __getUserSecrets;
}
export function deleteUserSecrets(payload) {
    var _a = serializer(_deleteUserSecretsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteUserSecretsResponse, {}).fromJSON;
    function __deleteUserSecrets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'DELETE',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildSecretsService.DeleteUserSecrets',
            url: resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl({
                protoPath: '/v1/app/secrets/user',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteUserSecrets.fromReq = fromReq;
    __deleteUserSecrets.__isAmbassador = true;
    return __deleteUserSecrets;
}
export function getSecretsGroupsPreview(payload) {
    var _a = serializer(_getSecretsGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSecretsGroupsResponse, {}).fromJSON;
    function __getSecretsGroupsPreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildSecretsService.GetSecretsGroupsPreview',
            url: resolveComWixpressBrandedappsProtosBuildBuildSecretsServiceUrl({
                protoPath: '/v1/secrets/groups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSecretsGroupsPreview.fromReq = fromReq;
    __getSecretsGroupsPreview.__isAmbassador = true;
    return __getSecretsGroupsPreview;
}
/** Get mobile config for an app, if you pass with signed instance as member/user then you'll get full data, otherwise only partial */
export function getBuildConfig(payload) {
    var _a = serializer(_getBuildConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBuildConfigResponse, {}).fromJSON;
    function __getBuildConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildConfigService.GetBuildConfig',
            url: resolveComWixpressBrandedappsProtosBuildBuildConfigServiceUrl({
                protoPath: '/v1/app/build-config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBuildConfig.fromReq = fromReq;
    __getBuildConfig.__isAmbassador = true;
    return __getBuildConfig;
}
/** Upserts mobile config for a given metasiteid */
export function updateBuildConfig(payload) {
    var _a = serializer(_updateBuildConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBuildConfigResponse, {}).fromJSON;
    function __updateBuildConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildConfigService.UpdateBuildConfig',
            url: resolveComWixpressBrandedappsProtosBuildBuildConfigServiceUrl({
                protoPath: '/v1/app/build-config',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBuildConfig.fromReq = fromReq;
    __updateBuildConfig.__isAmbassador = true;
    return __updateBuildConfig;
}
/**
 * Start a new build. If a new one for the given platform already exists, then return that
 * Build config is generated and then produced to kafka on a dedicated topic per platform
 */
export function buildOrchestratorServiceBuild(payload) {
    var _a = serializer(_buildRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_buildResponse, {}).fromJSON;
    function __buildOrchestratorServiceBuild(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildOrchestratorService.Build',
            url: resolveComWixpressBrandedappsProtosBuildBuildOrchestratorServiceUrl({
                protoPath: '/v1/app/builds',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __buildOrchestratorServiceBuild.fromReq = fromReq;
    __buildOrchestratorServiceBuild.__isAmbassador = true;
    return __buildOrchestratorServiceBuild;
}
/** Returns the last/current build for the given metasite */
export function getBuilds(payload) {
    var _a = serializer(_getBuildRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBuildResponse, {
        _build: _build,
        _buildStatus: _buildStatus,
    }).fromJSON;
    function __getBuilds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildOrchestratorService.GetBuilds',
            url: resolveComWixpressBrandedappsProtosBuildBuildOrchestratorServiceUrl({
                protoPath: '/v1/app/builds',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBuilds.fromReq = fromReq;
    __getBuilds.__isAmbassador = true;
    return __getBuilds;
}
/** Returns all updates that were sent for the given buildId */
export function getStatus(payload) {
    var _a = serializer(_getBuildStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBuildStatusResponse, {
        _buildStatus: _buildStatus,
    }).fromJSON;
    function __getStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildOrchestratorService.GetStatus',
            url: resolveComWixpressBrandedappsProtosBuildBuildOrchestratorServiceUrl({
                protoPath: '/v1/app/builds/{buildId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStatus.fromReq = fromReq;
    __getStatus.__isAmbassador = true;
    return __getStatus;
}
/** Returns all updates that were sent for the given buildId */
export function getPublicStatus(payload) {
    var _a = serializer(_getPublicStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPublicStatusResponse, {
        _buildStatus: _buildStatus,
    }).fromJSON;
    function __getPublicStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildOrchestratorService.GetPublicStatus',
            url: resolveComWixpressBrandedappsProtosBuildBuildOrchestratorServiceUrl({
                protoPath: '/v1/app/builds/{buildId}/public',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPublicStatus.fromReq = fromReq;
    __getPublicStatus.__isAmbassador = true;
    return __getPublicStatus;
}
/** Updates a given buildId with another status, this is called by build servers */
export function updateStatus(payload) {
    var _a = serializer(_updateBuildStatusRequest, { _buildStatus: _buildStatus }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBuildStatusResponse, {}).fromJSON;
    function __updateStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.build.BuildOrchestratorService.UpdateStatus',
            url: resolveComWixpressBrandedappsProtosBuildBuildOrchestratorServiceUrl({
                protoPath: '/v1/app/builds/{buildId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStatus.fromReq = fromReq;
    __updateStatus.__isAmbassador = true;
    return __updateStatus;
}
/** Get mobile config for an app, if you pass with signed instance as member/user then you'll get full data, otherwise only partial */
export function getMobileConfig(payload) {
    var _a = serializer(_getMobileConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMobileConfigResponse, {}).fromJSON;
    function __getMobileConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.mobile.MobileConfigService.GetMobileConfig',
            url: resolveComWixpressBrandedappsProtosMobileMobileConfigServiceUrl({
                protoPath: '/v1/app/mobile-config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMobileConfig.fromReq = fromReq;
    __getMobileConfig.__isAmbassador = true;
    return __getMobileConfig;
}
/** Upserts mobile config for a given metasiteid */
export function updateMobileConfig(payload) {
    var _a = serializer(_updateMobileConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMobileConfigResponse, {}).fromJSON;
    function __updateMobileConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.mobile.MobileConfigService.UpdateMobileConfig',
            url: resolveComWixpressBrandedappsProtosMobileMobileConfigServiceUrl({
                protoPath: '/v1/app/mobile-config',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMobileConfig.fromReq = fromReq;
    __updateMobileConfig.__isAmbassador = true;
    return __updateMobileConfig;
}
export function getByMetaSiteIds(payload) {
    var _a = serializer(_getByMetaSiteIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionsResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __getByMetaSiteIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionManagementService.GetByMetaSiteIds',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionManagementServiceUrl({
                protoPath: '/v1/app/stores/submissions/manangement/metasiteids',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getByMetaSiteIds.fromReq = fromReq;
    __getByMetaSiteIds.__isAmbassador = true;
    return __getByMetaSiteIds;
}
export function getByStatus(payload) {
    var _a = serializer(_getByStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionsResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __getByStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionManagementService.GetByStatus',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionManagementServiceUrl({
                protoPath: '/v1/app/stores/submissions/manangement/status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getByStatus.fromReq = fromReq;
    __getByStatus.__isAmbassador = true;
    return __getByStatus;
}
export function getWithError(payload) {
    var _a = serializer(_getWithErrorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionsResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __getWithError(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionManagementService.GetWithError',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionManagementServiceUrl({
                protoPath: '/v1/app/stores/submissions/manangement/error',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWithError.fromReq = fromReq;
    __getWithError.__isAmbassador = true;
    return __getWithError;
}
/** Get mobile config for an app, if you pass with signed instance as member/user then you'll get full data, otherwise only partial */
export function getStoresConfig(payload) {
    var _a = serializer(_getStoresConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStoresConfigResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __getStoresConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresConfigService.GetStoresConfig',
            url: resolveComWixpressBrandedappsProtosStoresStoresConfigServiceUrl({
                protoPath: '/v1/app/stores-config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStoresConfig.fromReq = fromReq;
    __getStoresConfig.__isAmbassador = true;
    return __getStoresConfig;
}
/** Upserts mobile config for a given metasiteid */
export function updateStoresConfig(payload) {
    var _a = serializer(_updateStoresConfigRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStoresConfigResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __updateStoresConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresConfigService.UpdateStoresConfig',
            url: resolveComWixpressBrandedappsProtosStoresStoresConfigServiceUrl({
                protoPath: '/v1/app/stores-config',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStoresConfig.fromReq = fromReq;
    __updateStoresConfig.__isAmbassador = true;
    return __updateStoresConfig;
}
/** Upserts mobile config for a given metasiteid */
export function bulkReadStoresConfig(payload) {
    var _a = serializer(_bulkReadStoresConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkReadStoresConfigResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appStoreConfig: _appStoreConfig,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _google_playPublishInfo: _google_playPublishInfo,
        _iapInAppPurchase: _iapInAppPurchase,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _playStoreConfig: _playStoreConfig,
        _product: _product,
        _publishInfo: _publishInfo,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
        _storesConfig: _storesConfig,
    }).fromJSON;
    function __bulkReadStoresConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresConfigService.BulkReadStoresConfig',
            url: resolveComWixpressBrandedappsProtosStoresStoresConfigServiceUrl({
                protoPath: '/v1/app/stores-config/bulk',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkReadStoresConfig.fromReq = fromReq;
    __bulkReadStoresConfig.__isAmbassador = true;
    return __bulkReadStoresConfig;
}
/** assign wixMemberEmails for both platforms for a given metasiteid */
export function assignWixMemberEmails(payload) {
    var _a = serializer(_assignWixMemberEmailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignWixMemberEmailsResponse, {}).fromJSON;
    function __assignWixMemberEmails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresConfigService.AssignWixMemberEmails',
            url: resolveComWixpressBrandedappsProtosStoresStoresConfigServiceUrl({
                protoPath: '/v1/app/stores-config/email-assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignWixMemberEmails.fromReq = fromReq;
    __assignWixMemberEmails.__isAmbassador = true;
    return __assignWixMemberEmails;
}
export function updatePublishedApps(payload) {
    var _a = serializer(_updatePublishedAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePublishedAppsResponse, {
        _storeUpdate: _storeUpdate,
    }).fromJSON;
    function __updatePublishedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresUpdatesService.UpdatePublishedApps',
            url: resolveComWixpressBrandedappsProtosStoresStoresUpdatesServiceUrl({
                protoPath: '/v1/app/stores/update/published-apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePublishedApps.fromReq = fromReq;
    __updatePublishedApps.__isAmbassador = true;
    return __updatePublishedApps;
}
export function getUpdateStatus(payload) {
    var _a = serializer(_getUpdateStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUpdateStatusResponse, {}).fromJSON;
    function __getUpdateStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresUpdatesService.GetUpdateStatus',
            url: resolveComWixpressBrandedappsProtosStoresStoresUpdatesServiceUrl({
                protoPath: '/v1/app/stores/update/status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUpdateStatus.fromReq = fromReq;
    __getUpdateStatus.__isAmbassador = true;
    return __getUpdateStatus;
}
export function triggerEventBulk(payload) {
    var _a = serializer(_triggerEventBulkRequest, { _google_playSubmissionEvent: _google_playSubmissionEvent, _submissionEvent: _submissionEvent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_triggerEventBulkResponse, {}).fromJSON;
    function __triggerEventBulk(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresUpdatesService.TriggerEventBulk',
            url: resolveComWixpressBrandedappsProtosStoresStoresUpdatesServiceUrl({
                protoPath: '/v1/app/stores/update/trigger-events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerEventBulk.fromReq = fromReq;
    __triggerEventBulk.__isAmbassador = true;
    return __triggerEventBulk;
}
export function releaseBrandedApps(payload) {
    var _a = serializer(_releaseBrandedAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_releaseBrandedAppsResponse, {}).fromJSON;
    function __releaseBrandedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.StoresUpdatesService.ReleaseBrandedApps',
            url: resolveComWixpressBrandedappsProtosStoresStoresUpdatesServiceUrl({
                protoPath: '/v1/app/stores/update/release',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __releaseBrandedApps.fromReq = fromReq;
    __releaseBrandedApps.__isAmbassador = true;
    return __releaseBrandedApps;
}
export function createAppStoreSecrets(payload) {
    var _a = serializer(_createAppStoreSecretsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAppStoreSecretsResponse, {}).fromJSON;
    function __createAppStoreSecrets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.CreateAppStoreSecrets',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/create-app-store-secrets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAppStoreSecrets.fromReq = fromReq;
    __createAppStoreSecrets.__isAmbassador = true;
    return __createAppStoreSecrets;
}
export function savePushNotificationsCredentials(payload) {
    var _a = serializer(_savePushNotificationCredentialsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAppStoreSecretsResponse, {}).fromJSON;
    function __savePushNotificationsCredentials(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.SavePushNotificationsCredentials',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/save-push-notification-credentials',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __savePushNotificationsCredentials.fromReq = fromReq;
    __savePushNotificationsCredentials.__isAmbassador = true;
    return __savePushNotificationsCredentials;
}
export function inviteWixEmailToAppStoreConnect(payload) {
    var _a = serializer(_inviteWixEmailToAppStoreConnectRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_inviteWixEmailToAppStoreConnectResponse, {}).fromJSON;
    function __inviteWixEmailToAppStoreConnect(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.InviteWixEmailToAppStoreConnect',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/invite-wix-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __inviteWixEmailToAppStoreConnect.fromReq = fromReq;
    __inviteWixEmailToAppStoreConnect.__isAmbassador = true;
    return __inviteWixEmailToAppStoreConnect;
}
export function submit(payload) {
    var _a = serializer(_submitAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submitAppResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __submit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.Submit',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/submit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __submit.fromReq = fromReq;
    __submit.__isAmbassador = true;
    return __submit;
}
export function updateStoreListings(payload) {
    var _a = serializer(_updateStoreListingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStoreListingsResponse, {}).fromJSON;
    function __updateStoreListings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.UpdateStoreListings',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/update-listings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStoreListings.fromReq = fromReq;
    __updateStoreListings.__isAmbassador = true;
    return __updateStoreListings;
}
export function updateAppleAppPublishedStatus(payload) {
    var _a = serializer(_updateAppleAppPublishedStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAppleAppPublishedStatusResponse, { _publishInfo: _publishInfo }).fromJSON;
    function __updateAppleAppPublishedStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.UpdateAppleAppPublishedStatus',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/update-apple-app-published-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAppleAppPublishedStatus.fromReq = fromReq;
    __updateAppleAppPublishedStatus.__isAmbassador = true;
    return __updateAppleAppPublishedStatus;
}
export function updateGoogleAppPublishedStatus(payload) {
    var _a = serializer(_updateGoogleAppPublishedStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateGoogleAppPublishedStatusResponse, {}).fromJSON;
    function __updateGoogleAppPublishedStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.LifecycleService.UpdateGoogleAppPublishedStatus',
            url: resolveComWixpressBrandedappsProtosStoresLifecycleServiceUrl({
                protoPath: '/v1/app/lifecycle/update-google-app-published-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateGoogleAppPublishedStatus.fromReq = fromReq;
    __updateGoogleAppPublishedStatus.__isAmbassador = true;
    return __updateGoogleAppPublishedStatus;
}
/**
 * Query apple for an existing app, creates one if it doesn't already exist.
 * If recreate is marked, then it deletes the existing app and recreate the new one.
 */
export function createApp(payload) {
    var _a = serializer(_createAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAppResponse, {}).fromJSON;
    function __createApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.unofficial.AppleUnofficialFacadeService.CreateApp',
            url: resolveComWixpressBrandedappsProtosStoresAppleUnofficialAppleUnofficialFacadeServiceUrl({
                protoPath: '/v1/app/stores/apple/unofficial/app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createApp.fromReq = fromReq;
    __createApp.__isAmbassador = true;
    return __createApp;
}
/**
 * Adds given productIds to the app - as ones that should be uploaded to Apple
 * Fetches all products from Apple and enriches our data with data from apple
 */
export function syncProducts(payload) {
    var _a = serializer(_syncProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_syncProductsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _product: _product,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
    }).fromJSON;
    function __syncProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.SyncProducts',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/sync-products',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __syncProducts.fromReq = fromReq;
    __syncProducts.__isAmbassador = true;
    return __syncProducts;
}
/** Lists all the products that require IAP for them to be sold in iOS */
export function listMandatoryProducts(payload) {
    var _a = serializer(_listMandatoryProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMandatoryProductsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _product: _product,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
    }).fromJSON;
    function __listMandatoryProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.ListMandatoryProducts',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/mandatory-products',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMandatoryProducts.fromReq = fromReq;
    __listMandatoryProducts.__isAmbassador = true;
    return __listMandatoryProducts;
}
export function listMandatoryProductsV2(payload) {
    var _a = serializer(_listMandatoryProductsV2Request, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMandatoryProductsV2Response, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _bookingsResponse: _bookingsResponse,
        _image: _image,
        _inAppPurchaseProduct: _inAppPurchaseProduct,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _media: _media,
        _mediaItem: _mediaItem,
        _origin: _origin,
        _plan: _plan,
        _product: _product,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
        _service: _service,
        _serviceInfo: _serviceInfo,
    }).fromJSON;
    function __listMandatoryProductsV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.ListMandatoryProductsV2',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/mandatory-products-v2',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMandatoryProductsV2.fromReq = fromReq;
    __listMandatoryProductsV2.__isAmbassador = true;
    return __listMandatoryProductsV2;
}
export function getIapProductsMetaData(payload) {
    var _a = serializer(_getIapProductsMetaDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getIapProductsMetaDataResponse, {}).fromJSON;
    function __getIapProductsMetaData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.getIapProductsMetaData',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/products-metadata',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getIapProductsMetaData.fromReq = fromReq;
    __getIapProductsMetaData.__isAmbassador = true;
    return __getIapProductsMetaData;
}
export function listIapProductsDetails(payload) {
    var _a = serializer(_listIapProductsDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listIapProductsDetailsResponse, {}).fromJSON;
    function __listIapProductsDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.ListIapProductsDetails',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/products-details',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listIapProductsDetails.fromReq = fromReq;
    __listIapProductsDetails.__isAmbassador = true;
    return __listIapProductsDetails;
}
export function syncProductsV2(payload) {
    var _a = serializer(_syncProductsV2Request, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_syncProductsV2Response, {}).fromJSON;
    function __syncProductsV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.SyncProductsV2',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/sync-products-v2',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __syncProductsV2.fromReq = fromReq;
    __syncProductsV2.__isAmbassador = true;
    return __syncProductsV2;
}
export function selectProducts(payload) {
    var _a = serializer(_selectProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_selectProductsResponse, {}).fromJSON;
    function __selectProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.AppleProductsService.SelectProducts',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapAppleProductsServiceUrl({
                protoPath: '/v1/app/stores/iap/select-products',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __selectProducts.fromReq = fromReq;
    __selectProducts.__isAmbassador = true;
    return __selectProducts;
}
export function getAppleProductsFromOrderId(payload) {
    var _a = serializer(_getAppleProductsFromOrderIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppleProductsFromOrderIdResponse, {}).fromJSON;
    function __getAppleProductsFromOrderId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.apple.iap.ProductsResolverService.GetAppleProductsFromOrderId',
            url: resolveComWixpressBrandedappsProtosStoresAppleIapProductsResolverServiceUrl({
                protoPath: '/v1/iap/products-from-order-id',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppleProductsFromOrderId.fromReq = fromReq;
    __getAppleProductsFromOrderId.__isAmbassador = true;
    return __getAppleProductsFromOrderId;
}
/** Triggers an event on the latest submission */
export function triggerEvent(payload) {
    var _a = serializer(_triggerEventRequest, { _google_playSubmissionEvent: _google_playSubmissionEvent, _submissionEvent: _submissionEvent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __triggerEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.TriggerEvent',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/app/stores/submission/trigger-event',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __triggerEvent.fromReq = fromReq;
    __triggerEvent.__isAmbassador = true;
    return __triggerEvent;
}
export function createSubmission(payload) {
    var _a = serializer(_createSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __createSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.CreateSubmission',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/app/stores/submission',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSubmission.fromReq = fromReq;
    __createSubmission.__isAmbassador = true;
    return __createSubmission;
}
export function getSubmission(payload) {
    var _a = serializer(_getSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __getSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.GetSubmission',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/app/stores/submission/latest',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubmission.fromReq = fromReq;
    __getSubmission.__isAmbassador = true;
    return __getSubmission;
}
/** Queries all submissions for the given metasiteid (from context) */
export function submissionServiceQuery(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_storesQueryResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __submissionServiceQuery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.Query',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/app/stores/submissions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __submissionServiceQuery.fromReq = fromReq;
    __submissionServiceQuery.__isAmbassador = true;
    return __submissionServiceQuery;
}
/** Queries latest submissions */
export function queryLatestSubmissions(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_storesQueryResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __queryLatestSubmissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.QueryLatestSubmissions',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/app/stores/submissions/query-latest',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLatestSubmissions.fromReq = fromReq;
    __queryLatestSubmissions.__isAmbassador = true;
    return __queryLatestSubmissions;
}
/** Assigns a user id to the active submission */
export function assignTo(payload) {
    var _a = serializer(_assignToRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __assignTo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'PUT',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.AssignTo',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/app/stores/submission/assignee',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignTo.fromReq = fromReq;
    __assignTo.__isAmbassador = true;
    return __assignTo;
}
export function getMetaData(payload) {
    var _a = serializer(_getMetaDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMetaDataResponse, {}).fromJSON;
    function __getMetaData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.GetMetaData',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/submission/metadata',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMetaData.fromReq = fromReq;
    __getMetaData.__isAmbassador = true;
    return __getMetaData;
}
export function retryCurrentSubmissionStage(payload) {
    var _a = serializer(_retryCurrentSubmissionStageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submissionResponse, {
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __retryCurrentSubmissionStage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'GET',
            methodFqn: 'com.wixpress.brandedapps.protos.stores.SubmissionService.RetryCurrentSubmissionStage',
            url: resolveComWixpressBrandedappsProtosStoresSubmissionServiceUrl({
                protoPath: '/v1/submission/retry',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __retryCurrentSubmissionStage.fromReq = fromReq;
    __retryCurrentSubmissionStage.__isAmbassador = true;
    return __retryCurrentSubmissionStage;
}
export function getPrioritizedApps(payload) {
    var _a = serializer(_getPrioritizedAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPrioritizedAppsResponse, {
        _activityLogEvent: _activityLogEvent,
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _storesSubmission: _storesSubmission,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __getPrioritizedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.queue.AdminQueueService.GetPrioritizedApps',
            url: resolveComWixpressBrandedappsProtosAdminQueueAdminQueueServiceUrl({
                protoPath: '/v1/app/admin-queue/prioritized-apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPrioritizedApps.fromReq = fromReq;
    __getPrioritizedApps.__isAmbassador = true;
    return __getPrioritizedApps;
}
export function queryQueue(payload) {
    var _a = serializer(_queryQueueRequest, {
        _queryV2: _queryV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryQueueResponse, {
        _brandedAppAdminItem: _brandedAppAdminItem,
        _brandedAppAdminItemBrandedAppData: _brandedAppAdminItemBrandedAppData,
        _brandedAppAdminItemNote: _brandedAppAdminItemNote,
        _brandedAppAdminItemSubmission: _brandedAppAdminItemSubmission,
        _google_playPublishInfo: _google_playPublishInfo,
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _publishInfo: _publishInfo,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __queryQueue(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.queue.AdminQueueService.QueryQueue',
            url: resolveComWixpressBrandedappsProtosAdminQueueAdminQueueServiceUrl({
                protoPath: '/v1/app/admin-queue/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryQueue.fromReq = fromReq;
    __queryQueue.__isAmbassador = true;
    return __queryQueue;
}
export function searchAdminApps(payload) {
    var _a = serializer(_searchAdminAppsRequest, { _queryV2: _queryV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchAdminAppsResponse, {
        _brandedAppAdminItem: _brandedAppAdminItem,
        _brandedAppAdminItemBrandedAppData: _brandedAppAdminItemBrandedAppData,
        _brandedAppAdminItemNote: _brandedAppAdminItemNote,
        _brandedAppAdminItemSubmission: _brandedAppAdminItemSubmission,
        _google_playPublishInfo: _google_playPublishInfo,
        _google_playSubmission: _google_playSubmission,
        _google_playSubmissionEvent: _google_playSubmissionEvent,
        _publishInfo: _publishInfo,
        _submission: _submission,
        _submissionEvent: _submissionEvent,
    }).fromJSON;
    function __searchAdminApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.queue.AdminQueueService.SearchAdminApps',
            url: resolveComWixpressBrandedappsProtosAdminQueueAdminQueueServiceUrl({
                protoPath: '/v1/app/admin-queue/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchAdminApps.fromReq = fromReq;
    __searchAdminApps.__isAmbassador = true;
    return __searchAdminApps;
}
/** Create a new activity log event */
export function createEvent(payload) {
    var _a = serializer(_createEventRequest, {
        _activityLogEvent: _activityLogEvent,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createEventResponse, {}).fromJSON;
    function __createEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.ActivityLogService.CreateEvent',
            url: resolveComWixpressBrandedappsProtosAdminActivityLogServiceUrl({
                protoPath: '/v1/app/activity-log',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createEvent.fromReq = fromReq;
    __createEvent.__isAmbassador = true;
    return __createEvent;
}
/** Query all activity log events */
export function query(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryResponse, {
        _activityLogEvent: _activityLogEvent,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.ActivityLogService.Query',
            url: resolveComWixpressBrandedappsProtosAdminActivityLogServiceUrl({
                protoPath: '/v1/app/activity-log/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/** Queries latest activity log events */
export function queryLatest(payload) {
    var _a = serializer(_queryV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryResponse, {
        _activityLogEvent: _activityLogEvent,
    }).fromJSON;
    function __queryLatest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'POST',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.ActivityLogService.QueryLatest',
            url: resolveComWixpressBrandedappsProtosAdminActivityLogServiceUrl({
                protoPath: '/v1/app/activity-log/query-latest',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLatest.fromReq = fromReq;
    __queryLatest.__isAmbassador = true;
    return __queryLatest;
}
export function deleteAll(payload) {
    var _a = serializer(_deleteAllRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAllResponse, {}).fromJSON;
    function __deleteAll(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.mobile.v1.branded_app',
            method: 'DELETE',
            methodFqn: 'com.wixpress.brandedapps.protos.admin.ActivityLogService.DeleteAll',
            url: resolveComWixpressBrandedappsProtosAdminActivityLogServiceUrl({
                protoPath: '/v1/app/activity-log',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAll.fromReq = fromReq;
    __deleteAll.__isAmbassador = true;
    return __deleteAll;
}
//# sourceMappingURL=http.impl.js.map